<div class="as-main-container-privacy">
  <div class="as-privacy" [ngClass]="{ 'as-modal-size': modal }">
    <h1>Aviso de Privacidad</h1>
    <p>
      <strong>Apreciables clientes y proveedores del Grupo Futurama</strong>
    </p>
    <p>
      En cumplimiento con la Ley Federal de Protección de Datos Personales en
      posesión de los particulares, hacemos de su conocimiento lo siguiente:
    </p>
    <p>
      <strong>Operadora Futurama S.A. de C.V.</strong> es la responsable de
      recabar, custodiar y tratar los datos personales que nos proporcione.
      Nuestro domicilio se encuentra en Paseo de las Facultades #601, Colonia
      Los Huertos, Chihuahua, Chih. Teléfono en Cd. Chihuahua: (614) 442 1111.
    </p>
    <p>
      Los datos personales que recabaremos y que están sujetos al control
      exigido por la ley de protección de datos personales en posesión de los
      particulares son:
    </p>
    <ul>
      <li>Nombre</li>
      <li>Dirección</li>
      <li>Teléfono</li>
      <li>Correo electrónico</li>
      <li>Fecha de nacimiento</li>
      <li>Hábitos de consumo</li>
      <li>
        Datos de los dispositivos y actividad realizada en los servicios
        proporcionados por Alsuper en sus tiendas físicas, así como las
        realizadas por medio de la aplicación del servicio de e-commerce.
      </li>
    </ul>
    <p>
      La información que nos sea proporcionada, será utilizada por
      <strong>Operadora Futurama S.A de C.V.</strong> y/o sus empresas filiales
      para efecto de verificación de la misma, investigaciones de mercado,
      propósitos de mercadeo, envío de publicidad, promociones, brindarles
      servicio que nos solicite, atender quejas y aclaraciones.
    </p>
    <p>
      Los datos personales proporcionados, sólo podrán ser transferidos a
      filiales de <strong>Operadora Futurama S.A de C.V.</strong> y a terceros
      para proveer los servicios y para los mismos fines citados en este aviso
      de privacidad.
    </p>
    <p>
      Todo dato personal será protegido por medios y recursos técnicos y
      administrativos para salvaguardar la información y garantizar su
      confidencialidad.
    </p>
    <p>
      Usted puede ejercer sus derechos de acceso, rectificación, cancelación y
      oposición conforme al Art. 21 de la Ley, mediante un escrito dirigido a la
      dirección indicada o al correo electrónico: alsuperinfo&#64;alsuper.com,
      señalando por lo menos:
    </p>
    <p>
      Nombre, domicilio o medio para recibir comunicaciones. identificación o
      medio que acredite personalidad de representante legal. precisar además
      los datos personales a los que se requiera accesar, rectificar, cancelar u
      oponer cualquier otro elemento que crea pertinente.
    </p>
    <p>
      Con el objeto de proteger sus datos personales, mantendremos la
      confidencialidad y resguardo de su información de manera efectiva,
      estableciendo las medidas de seguridad administrativas, técnicas y físicas
      para evitar su daño, vulneración, pérdida, alteración, destrucción, uso o
      divulgación indebida a través de procedimientos y controles internos en el
      manejo de su información personal.
    </p>
    <p>
      <strong>Operadora Futurama S.A. de C.V.</strong> se reserva el derecho de
      modificar y/o actualizar este Aviso de Privacidad, el cual se publicará en
      <a href="https://www.alsuper.com" target="_blank">www.alsuper.com</a>.
    </p>
    <mat-label class="as-attentively as-font-semibold as-text-align-center">
      <p>
        <strong>ATENTAMENTE:</strong><br />
        Operadora Futurama S.A. de C.V. y empresas filiales.<br />
        Calle Paseo de las Facultades #601. Chihuahua, Chih. México.
      </p>
    </mat-label>
  </div>
</div>
